// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__2GRms","form":"LoginForm_form__HZ40M","buttons":"LoginForm_buttons__QY9bW"};